// chat-eu apps/web/src/endpoints.ts

// Public vs private AppSync HTTP endpoints (if you still use them elsewhere)
export const publicAgentApiEndpoint =
  process.env.REACT_APP_PUBLICAGENTAPIENDPOINT as string;

export const privateAgentApiEndpoint =
  process.env.REACT_APP_PRIVATEAGENTAPIENDPOINT as string;

// GraphQL proxy endpoint used by the web client.
// - In the browser: defaults to same-origin /graphql (CloudFront → API GW → Express → private AppSync)
// - In SSR / Node: falls back to "/graphql", which will resolve correctly when served behind the API domain.
export const graphqlProxyEndpoint =
  (process.env.REACT_APP_GRAPHQLPROXY_ENDPOINT as string) ||
  (typeof window !== "undefined" ? `${window.location.origin}/graphql` : "/graphql");

export const cognitoConfig = {
  region: process.env.REACT_APP_REGION as string,
  userPoolId: process.env.REACT_APP_COGNITOPOOL as string,
  userPoolClientId: process.env.REACT_APP_COGNITOCLIENTAUTH as string,
  userPoolDomain: process.env.REACT_APP_COGNITODOMAIN as string,
  userPoolRedirectSignInUri: process.env.REACT_APP_COGNITOREDIRECTSIGNINURL as string,
  userPoolRedirectSignOutUri: process.env.REACT_APP_COGNITOREDIRECTSIGNOUTURL as string,
};

export const fmHandlerArns = [
  {
    label: "start",
    name: process.env.REACT_APP_HANDLERCLAUDESTART,
  },
  {
    label: "question-and-answer",
    name: process.env.REACT_APP_HANDLERCLAUDEQUESTIONANDANSWER,
  },
];

export const uploadTable = process.env.REACT_APP_UPLOADSTABLE as string;
export const eventTable = process.env.REACT_APP_EVENTSTABLE as string;
export const userTable = process.env.REACT_APP_USERSTABLE as string;

export const enableConfigureAgents =
  process.env.REACT_APP_ENABLECONSTRUCTINGAGENTS === "true";
